import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SuccessModal = ({ isOpen }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[var(--color-background)]/80 backdrop-blur-sm">
      <div className="w-full max-w-md bg-[var(--color-card)] rounded-2xl shadow-2xl border border-[var(--color-border)] overflow-hidden animate-in fade-in zoom-in duration-300">
        <div className="p-6 md:p-8 text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-4 md:mb-6 rounded-full bg-[var(--color-success)]/10 flex items-center justify-center">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[var(--color-success)] flex items-center justify-center animate-in zoom-in duration-500 delay-150">
              <Icon name="Check" size={32} color="var(--color-success-foreground)" strokeWidth={3} />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-foreground)] mb-3">
            Registration Complete!
          </h2>
          
          <p className="text-sm md:text-base text-[var(--color-muted-foreground)] mb-6 md:mb-8">
            Your Kryptostash account has been successfully created. Please verify your email and then log in to access your dashboard.
          </p>

          <div className="bg-[var(--color-muted)] rounded-lg p-4 mb-6 md:mb-8">
            <div className="flex items-start gap-3 text-left">
              <Icon name="Mail" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <div className="text-xs md:text-sm">
                <p className="font-medium text-[var(--color-foreground)] mb-1">
                  Next Steps
                </p>
                <ol className="text-[var(--color-muted-foreground)] space-y-1 list-decimal list-inside">
                  <li>Check your email inbox for verification link</li>
                  <li>Click the link to verify your account</li>
                  <li>Return and log in to start trading</li>
                </ol>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Button
              variant="default"
              size="lg"
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              fullWidth
              onClick={() => navigate('/homepage')}
            >
              Return to Homepage
            </Button>
          </div>

          <div className="mt-6 pt-6 border-t border-[var(--color-border)]">
            <p className="text-xs text-[var(--color-muted-foreground)]">
              Need help?{' '}
              <a href="#" className="text-[var(--color-primary)] hover:underline">
                Contact Support
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;